var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.798697 11.5102C1.10308 11.5102 1.29201 11.372 1.78008 10.8911L4.27816 8.43517C4.3044 8.40959 4.33064 8.38912 4.35688 8.38912C4.38312 8.38912 4.40411 8.40959 4.43035 8.43517L6.93367 10.8911C7.41124 11.3669 7.61067 11.5102 7.90981 11.5102C8.30341 11.5102 8.62354 11.2748 8.62354 10.7325V1.99351C8.62354 0.888344 8.03576 0.310181 6.91268 0.310181H1.80107C0.677992 0.310181 0.09021 0.888344 0.09021 1.99351V10.7325C0.09021 11.2748 0.405093 11.5102 0.798697 11.5102ZM1.26053 9.94965C1.1923 10.0213 1.13457 9.9957 1.13457 9.89849V2.06002C1.13457 1.58419 1.38648 1.32836 1.89554 1.32836H6.81821C7.32203 1.32836 7.57393 1.58419 7.57393 2.06002V9.89849C7.57393 9.9957 7.52145 10.0162 7.44798 9.94965L4.69275 7.26861C4.5668 7.15093 4.46184 7.10488 4.35688 7.10488C4.25192 7.10488 4.14171 7.15093 4.021 7.26861L1.26053 9.94965Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon-bookmark.1177f7ea74fc03ece8344a92018d211c.svg";
export { ForwardRef as ReactComponent };